import MeetingCard from './MeetingCard'

export default MeetingCard
